import { keepPreviousData, useInfiniteQuery } from '@tanstack/react-query';
import axiosInstance from '../../../utils/axios';
import { defaultQueryOptions, QueryKeys } from '../../querys/querys.enum';
import { IOrganizationsResponse } from '../../../models/Interface/Organization.interface';

export interface IFileterInterface {
  value: string;
  label: string;
  search?: string;
}
export interface IFilters {
  email?: string;
  organizationName?: string;
  id?: number;
  search?: string;
}

const useOrganizations = (isEnabled: boolean, params: IFilters) => {
  return useInfiniteQuery<IOrganizationsResponse>({
    queryKey: [QueryKeys.ORGANIZATIONS, params],
    initialPageParam: 1,
    queryFn: async ({ pageParam = 1, queryKey }) => {
      const d = queryKey[1] as IFilters;

      const email = d.email ? `&email=${encodeURIComponent(d.email)}` : '';
      const organizationName = d.organizationName
        ? `&organizationName=${encodeURIComponent(d.organizationName)}`
        : '';

      const search = d.search ? `&search=${encodeURIComponent(d.search)}` : '';
      const id = d.id ? `&id=${encodeURIComponent(d.id)}` : '';

      return (
        await axiosInstance.get(
          `/organizations?page=${pageParam}${email}${organizationName}${search}${id}`
        )
      ).data;
    },
    getNextPageParam: (lastPage, allPages, lastPageParam, allParams) => {
      if (lastPage.meta.totalPage === lastPage.meta.page) return undefined;
      return lastPage.meta.page + 1;
    },
    ...defaultQueryOptions,
    refetchOnWindowFocus: true,
    initialData: undefined,
    enabled: isEnabled,
    placeholderData: keepPreviousData,
  });
};
export default useOrganizations;
